import ReactDOM from 'react-dom';

import { App } from './App';

const rootElement = document.getElementById('root') as HTMLDivElement;

ReactDOM.render(<App />, rootElement);
